import { SharePriceModel } from "models/sharePriceModel";
import { SharePrice } from "services/cms/models";
import { Image } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

import { ResolvedMegaMenuCtaButton, transformCtaButton } from "./headerMegaMenuCTAResolver";
import imageResolver, { ResolvedImage } from "./imageResolver";

export type ResolvedSharePrice = {
    codename: string;
    heading: string;
    image: ResolvedImage;
    cta?: ResolvedMegaMenuCtaButton;
    sharePriceModel: SharePriceModel;
    type: ContentTypeCodenames.SharePrice;
};

const sharePriceResolver = (data: SharePrice): ResolvedSharePrice => {
    const linkedImage = data?.elements?.image?.linkedItems[0] as Image;
    const linkedCta = data.elements.cta.linkedItems[0];

    return {
        codename: data.system.codename,
        image: imageResolver(linkedImage),
        heading: data.elements.heading?.value,
        cta: linkedCta && transformCtaButton(linkedCta),
        sharePriceModel: data.elements.data as SharePriceModel,
        type: ContentTypeCodenames.SharePrice,
    };
};

export default sharePriceResolver;
